var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAToZIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.694,
    height: 23.481,
    viewBox: "0 0 21.694 23.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-473.462 -308.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M490.929,327.822h-1.453V310.046a1.118,1.118,0,0,0-2.232,0v17.776h-1.453a.843.843,0,0,0-.7,1.379l2.568,2.967a.941.941,0,0,0,1.4,0l2.568-2.967A.843.843,0,0,0,490.929,327.822Z",
    transform: "translate(3.322 -0.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M481.746,332.869H481.2a.558.558,0,0,1-.522-.362l-1.052-2.789h-3.488l-1.051,2.789a.559.559,0,0,1-.522.362h-.549a.557.557,0,0,1-.521-.758l3.608-9.434a.559.559,0,0,1,.521-.358h.517a.559.559,0,0,1,.521.358l3.6,9.435a.559.559,0,0,1-.522.757Zm-5.013-4.718h2.306l-1.154-3.057Z",
    transform: "translate(0 -12.963)",
    fill: "#126af8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M481.838,319.869h-7.324a.584.584,0,0,1-.607-.558v-.4a.529.529,0,0,1,.112-.322l5.926-7.683H474.72a.583.583,0,0,1-.607-.558v-.471a.583.583,0,0,1,.607-.558h7.09a.583.583,0,0,1,.607.558v.405a.534.534,0,0,1-.112.322l-5.912,7.677h5.445a.584.584,0,0,1,.607.558v.471A.584.584,0,0,1,481.838,319.869Z",
    transform: "translate(-0.445 12.563)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAToZIcon);
export default __webpack_public_path__ + "static/media/sort-a-to-z-icon.0c9a3ad4044a4be97c9b44fb73a37eb2.svg";
export { ForwardRef as ReactComponent };